import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Footer } from '../../features/footer/Footer';
import { Header } from '../../features/header/Header';
import { Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import {
  withAuthentication,
  getThoughtSpotToken,
} from '../../common/authentication';
import {
  AppEmbed,
  AuthType,
  init,
  Page,
  RuntimeFilterOp,
} from '@thoughtspot/visual-embed-sdk';
import config from '../../config';

const IFrameContainer = styled.div``;

class DashboardEditor extends React.Component {
  constructor(props) {
    super(props);
    this.tsContainerRef = React.createRef();
    this.state = { selectedCurrency: null };
  }

  componentDidMount() {
    init({
      thoughtSpotHost: config.thoughtSpotHost,
      authType: AuthType.AuthServer,
      username: this.props.authState.username,
      getAuthToken: () =>
        new Promise((resolve, reject) => {
          getThoughtSpotToken(this.props.authState.accessToken).then(
            (tsinfo) => {
              resolve(tsinfo.thoughtSpotToken);
            },
          );
        }),
    });

    this.renderDashboard(this.tsContainerRef.current);
  }

  componentDidUpdate() {
    this.renderDashboard(this.tsContainerRef.current);
  }

  renderDashboard(domRef) {
    const pinboard = new AppEmbed(domRef, {
      frameParams: {
        width: '100%',
        height: '1500px',
      },
      fullHeight: true,
      pageId: Page.Pinboards,
    });
    pinboard.render();
  }

  render() {
    return (
      <>
        <Helmet>
          <title>{`PARAMETA Solutions Trading Analytics - Dashboard Builder`}</title>
          <meta name="description" content="Description of DashboardPage" />
        </Helmet>
        <Header />
        <h4 className="ml-5 mb-4">Dashboard Builder</h4>
        <Row>
          <Col>
            <IFrameContainer ref={this.tsContainerRef} />
          </Col>
        </Row>
        <Footer />
      </>
    );
  }
}

export default withAuthentication(withRouter(injectIntl(DashboardEditor)));
